import React from "react";

interface IAttributeParamProps {
  attributeWithValue: any;
}

const TextAttribute: React.FC<IAttributeParamProps> = ({
  attributeWithValue,
}) => {
  return <div>{attributeWithValue?.values[0]}</div>;
};

export default TextAttribute;
